// Only a checkout confirmation can request this tab-scoped post-login return.
// Keep it through MFA and popup/redirect SSO, then consume it after sign-in.
const KEY = 'gab:checkout:sign-in-return';
const MAX_AGE = 20 * 60 * 1000;

export function rememberCheckoutSignInReturn({ contextId, checkoutType }) {
  try {
    if (!contextId) return;
    const params = new URLSearchParams({ checkoutContext: contextId });
    if (typeof checkoutType === 'string') params.set('checkoutType', checkoutType);
    window.sessionStorage.setItem(KEY, JSON.stringify({ path: `/payment-successful?${params}`, createdAt: Date.now() }));
  } catch (_) {}
}

export function consumeCheckoutSignInReturn() {
  try {
    const record = JSON.parse(window.sessionStorage.getItem(KEY) || 'null');
    window.sessionStorage.removeItem(KEY);
    if (!record || !Number.isFinite(record.createdAt)
      || Date.now() - record.createdAt > MAX_AGE || record.createdAt > Date.now()) return null;
    const url = new URL(record.path, window.location.origin);
    if (url.origin !== window.location.origin || url.pathname !== '/payment-successful'
      || !url.searchParams.get('checkoutContext')) return null;
    return url.pathname + url.search;
  } catch (_) { return null; }
}
